// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contaner_buttons {\n    flex-direction: row;\n    display: flex ;\n    align-items:center;\n    margin-top:0.5%\n}\n\n/* .submit_button{ */\n    /* margin-top: 5; */\n    /* margin-right: 5; */\n/* } */\n/* style={{marginRight:5,maarginTop:\"1%\"}} */\n@media only screen and (max-width: 600px) {\n    .contaner_buttons {\n        flex-direction: column;\n        display: flex \n    }\n\n    .submit_button{\n        margin-top: 1%;\n    }\n } ", ""]);
// Exports
module.exports = exports;
